import { render, staticRenderFns } from "./BonusesCard.htm?vue&type=template&id=98b2a734&scoped=true&"
import script from "./BonusesCard.ts?vue&type=script&lang=js&"
export * from "./BonusesCard.ts?vue&type=script&lang=js&"
import style0 from "./BonusesCard.scss?vue&type=style&index=0&id=98b2a734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b2a734",
  null
  
)

export default component.exports